<!--

SELECIONA PLANOS PARA PAGAMENTO DO APP NFE

-->

<template>
  <div class="registro">
    <header class="shared-header">
      <div class="col-md-12 col-12 text-center">
        <a class="valign" href="#">
          <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"
            alt="Logo Nota Brasil">
        </a>
      </div>
    </header>

    <transition name="fade" mode="out-in">
      <div class="container-planos" v-if="!sucesso" style="margin-bottom: 100px">
        <div v-if="isEndTrial">
          <div class="activation text-center mb-2">
            <h3>Seu período de testes expirou!</h3>
          </div>
          <div class="activation text-center mb-2">
            <h3>Selecione agora um plano para continuar a utilizar o Nota Brasil</h3>
          </div>
        </div>

        <div id="NFE">
          <div class="text-center mb-5" style="margin-top:100px">
            <div class="w-100 title">Adicione Complementos</div>
          </div>
        </div>
        <div class="complementos " v-if="planSubscriptionSteps.length == 1">
          <h4>Selecione funcionalidades adicionais para melhorar o seu plano</h4>
          <hr>
          <div v-if="plans.planos">
            <div class=" border shadow my-3 component-addons" v-for="(comp, index) in selectedPlan.addons" :key="index">
              <div class="px-5 py-3 d-flex row align-items-center ">
                <div class="d-flex col-6 align-items-start">
                  <input class="mr-5" style="width:16px; height: 16px" v-model="comp.selected" type="checkbox" name=""
                    id="">
                  <strong class="mr-4">{{ comp.nome }}</strong>
                  <!-- <strong class="mr-3">{{!comp.limitado ? 'Ilimitado' : 'Limitado'}}</strong> -->
                  <div class="container-info cursor-pointer " v-if="comp.tooltip">
                    <i class="fa fa-info-circle" style="color:#0C72AD" @mouseover="handleShowTooltip(index)"
                      @mouseleave="handleShowTooltip(index)"></i>
                  </div>

                </div>

                <div class="d-flex flex-col text-right align-items-center justify-content-end col-6 ">
                  <div class="line d-block mr-5" style="height:30px; opacity: 50%;"></div>
                  <strong class="text-right mx-5">R$ {{ comp.precoMensal | formatValue(2) }} / mês</strong>
                </div>
                <transition name="easeShow">
                  <small style="margin-left:80px; line-height: 0px;" v-if="comp.showTooltip">{{ comp.tooltip }}</small>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <div class="container-dados-faturamento" v-if="planSubscriptionSteps.length == 2">
          <h3>Dados Para Nota Fiscal</h3>
          <hr />
          <div class="default-container mt-4">

            <div class="my-3">
              <label class="lbl-edit pb-1" for="">Tipo de Pessoa</label>
              <br>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="F">
              <label class="lbl" for="">Pessoa Fisica</label>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="J">
              <label class="lbl" for="">Pesso Juridica</label>
            </div>
            <div class="row">
              <form-field ref="nome" v-model="dadosFaturamento.nome" type="text" col="4" label="Nome" name="nome"
                :v-errors="errors" v-validate="{ required: true, max: 60, cpf: false }"></form-field>
              <div class="col-4" v-if="dadosFaturamento.tppessoa == 'J'">
                <form-field ref="cnpj" v-model="dadosFaturamento.cnpjcpf" type="cnpj" col="12" label="CNPJ" name="cnpj"
                  :v-errors="errors" v-validate="{ required: true, cnpj: true, cpf: false }"
                  v-if="dadosFaturamento.tppessoa == 'J'"></form-field>
              </div>
              <div class="col-4" v-if="dadosFaturamento.tppessoa == 'F'">
                <form-field ref="cpf" v-model="dadosFaturamento.cnpjcpf" type="cnpj" col="12" label="CPF" name="cpf"
                  :v-errors="errors" v-validate="{ required: true, cpf: true, cnpj: false }"
                  v-if="dadosFaturamento.tppessoa == 'F'"></form-field>
              </div>
            </div>

            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.cep" type="cep" col="4" label="Cep" name="cep" :v-errors="errors"
                v-validate="{ required: true }" @update="updateCep"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.endereco" type="text" col="4" label="Endereço" name="ende"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
              <form-field v-model="dadosFaturamento.nr" type="text" col="2" label="Número" name="endenr"
                :v-errors="errors" v-validate="{ required: true, max: 20 }"></form-field>
              <form-field v-model="dadosFaturamento.complemento" type="text" col="4" label="Complemento" name="endecomp"
                :v-errors="errors" v-validate="{ max: 40 }"></form-field>
            </div>

            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.bairro" type="text" col="4" label="Bairro" name="bairro"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.uf" type="select2" col="4" label="Estado" name="uf" :v-errors="errors"
                v-validate="{ required: true }" :select2="{ entity: 'estado', minlength: 0 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.codmun" type="select2" col="4" label="Cidade" name="codmun"
                :v-errors="errors" v-validate="{ required: true }"
                :select2="{ entity: 'mun/uf/' + dadosFaturamento.uf, minlength: 2 }"></form-field>
            </div>
          </div>
        </div>

        <hr>

        <!-- <div class="text-center px-5">
                    <h2> Em caso de dúvidas, entre em contato com nosso atendimento via chat </h2>
                    <h5> Nossos planos incluem suporte via CHAT de segunda à sexta das 08:30 às 17:30 </h5>
                </div> -->

      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="sucesso">
        <div class="activation text-center">
          <h2 class="title">Sucesso!</h2>
          <h3>Estamos aguardando a confirmação do seu pagamento.</h3>
        </div>
        <div class="row justify-content-center w-100">
          <button type="button" class="app-button" @click="handleInicio"> Retornar ao Nota Brasil </button>
        </div>
      </div>
    </transition>

    <div class="bottom-bar" v-if="showComplementos">
      <div>
        <!-- <button class="btn-finalizar" @click="handleAssinar">Assinar</button> -->
        <span>Total: R${{ resumo.total | formatValue }}</span>
      </div>
    </div>
    <div class="footer fixed-bottom shadow-lg overflow-x-hidden">
      <div class="footer-container my-3 lbl-gray" style="font-size:14px; font-weight:400">

        <button class="btn btn-outline-secondary px-3" style="max-height:50px"
          @click="handleBackStepToPlan">Voltar</button>

        <div class=" d-flex flex-wrap" v-if="selectedComplemento && selectedPlan && selectedRecurso"
          style="font-size:15px;">
          <div class="d-flex flex-column">
            <div v-if="selectedComplemento">
              <span>Resumo da compra:
                R$ {{ (selectedComplemento.precoTotal).toFixed(2) | formatValue(2) }}/mês
              </span>
            </div>
          </div>
          <div class="line mx-4 d-none d-lg-block"></div>
          <div class="d-flex h-auto h-lg-100 align-items-end" style="max-width: 210px">
            <span>Total: R$ {{ selectedComplemento.precoTotal / 30 * diasRestantes | formatValue(2) }}
              <span class="d-none d-lg-block"> no boleto ou cartão de crédito </span><strong>em até 12x</strong>
            </span>
          </div>
        </div>

        <button :disabled="!selectedPlan" class="btn btn-success px-3" style="max-height:50px"
          @click="handleAddStepToPlan">Avançar</button>

      </div>
    </div>
  </div>
</template>

<script>
import { apiORDS, apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String },
  },

  data() {
    return {
      showTooltipComplemento: false,
      dadosFaturamento: {},
      hasValid: false,
      planSubscriptionSteps: [1],
      currentPlan: null,
      currentRecorrencia: null,
      diasRestantes: 0,
      title: '',
      errmessages: null,
      sucesso: false,

      showComplementos: false,
      plans: {},
      plano: {}

    }
  },

  computed: {
    getBillingMethod: function () {
      const tipoSelecionado = this.selectedRecurso.tipo

      return tipoSelecionado == 'ANUAL' ? 12 : tipoSelecionado == 'TRIMESTRAL' ? 3 : 1
    },
    selectedPlan: function () {
      if (this.currentPlan) {
        const selected = this.plans.planos.find(plan => plan.id == this.currentPlan);
        return selected
      }
    },
    selectedRecurso: function () {
      if (this.currentPlan) {
        const selectedPlan = this.plans.planos.find(plan => plan.id == this.currentPlan ? plan : null);

        let selectedRec = {}

        if (selectedPlan) {
          selectedRec = selectedPlan.recorrencias.find(rec => rec.tipo == this.currentRecorrencia ? rec : null);
        }
        if (selectedPlan) {
          return selectedRec
        }
      }
    },
    selectedComplemento: function () {
      if (this.currentPlan) {
        const selectedPlan = this.plans.planos.find(plan => plan.id == this.currentPlan);
        let selectedsComp = {
          addons: [],
          precoTotal: 0
        }

        if (selectedPlan) {
          selectedPlan.addons.forEach(comp => {
            if (comp.selected) {
              selectedsComp.addons.push(comp);
              selectedsComp.precoTotal = selectedsComp.precoTotal + comp.precoMensal
            }
          });
        }
        if (selectedsComp) {
          return selectedsComp
        }
      }

    },
    isEndTrial: function () {
      return SysVars.appEndTrial
    },

    isBlocked: function () {
      return SysVars.appBlocked
    },

  },

  methods: {
    handleShowTooltip(indice) {

      if (!this.selectedPlan.addons[indice].showTooltip) {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', true);
      } else {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', false);
      }
    },
    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = SysVars.endereco.logradouro;
      this.dadosFaturamento.bairro = SysVars.endereco.bairro;
      this.dadosFaturamento.codmun = SysVars.endereco.ibge;
      this.dadosFaturamento.uf = SysVars.endereco.uf;
    },
    async handleValidadados() {
      await this.$validator.validateAll().then(isValid => {
        this.hasValid = false
        if (!isValid || !this.dadosFaturamento.cnpjcpf) {
          this.$erpToastError(!this.dadosFaturamento.cnpjcpf ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
        } else {
          this.hasValid = true
        }
      })
    },
    handleBackStepToPlan() {
      if (this.planSubscriptionSteps.length <= 1) {
        this.$router.go(-1);
      }
      if (this.planSubscriptionSteps.length <= 2 && this.selectedComplemento) {
        this.loadDataPlans();

      }
      this.planSubscriptionSteps.pop();
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      })
    },
    async handleAddStepToPlan() {

      window.scrollBy(0, window.innerHeight);

      if (this.planSubscriptionSteps.length == 2) {
        await this.handleValidadados();
      }
      if (this.planSubscriptionSteps.length < 3) {
        if (this.planSubscriptionSteps.length == 3 && !this.hasValid) {
          return;
        }
        this.planSubscriptionSteps.push(this.planSubscriptionSteps.length + 1)
      }
      if (this.planSubscriptionSteps.length == 3) {
        this.handleAssinar();
      }


    },
    loadParams() {
      let params = SysVars.planosParams;

      this.currentPlan = params.planoAtual;
      this.currentRecorrencia = params.recorrencia;
      this.dadosFaturamento = params.dadosFaturamento
      this.diasRestantes = params.diasRestantes
      if (this.dadosFaturamento.tppessoa == 'J')
        this.dadosFaturamento.cnpjcpf = this.dadosFaturamento.cnpj
      else
        this.dadosFaturamento.cnpjcpf = this.dadosFaturamento.cpf

    },
    async loadDataPlans() {

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })
      await apiORDS(this.$store.getters.urlApp + '/planos/')
        .then((data) => {
          this.plans = { ...data.ERP };
        })
    },

    handleInicio() {
      window.location.href = '/';
    },
    async handleAssinar() {

      let objeto = {}
      objeto.plano = this.selectedPlan.id;
      objeto.app = SysVars.planosParams.app;
      objeto.recorrencia = this.selectedRecurso.tipo;
      objeto.newAddon = true;
      objeto.complementos = new Array;

      this.selectedPlan.addons.forEach(ad => {
        if (ad.selected) {
          objeto.complementos.push({
            uuid: ad.uuid,
            quantidade: null
          });
        }
      });

      objeto.dadosFaturamento = this.dadosFaturamento
      if (this.dadosFaturamento.tppessoa == 'J')
        objeto.dadosFaturamento.cnpj = this.dadosFaturamento.cnpjcpf
      else
        objeto.dadosFaturamento.cpf = this.dadosFaturamento.cnpjcpf

      this.$appLoading(true);
      let sendData = objeto
      const pagseguro = await apiORDSapp(this, 'sessao/pagseguro/', 'post', sendData);
      this.$appLoading(false);

      let self = this

      window.open(pagseguro.href, "_blank");
      self.$apploading(false)
      var resultoptions = {};
      resultoptions.updatedatatable = false;
      self.sucesso = true;
      this.plansubscriptionsteps = [1]

    }

  },
  async mounted() {

    if (!SysVars.planosParams) {
      this.$router.push('/minhaconta')
    }

    this.loadParams();

    await this.loadDataPlans();

    this.$nextTick(() => {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    setTimeout(function () {
      Tawk_API.hideWidget();
    }, 1000);

  }

}

</script>

<style scoped>
.component-addons {
  transition: all 0.5s ease;
}

@keyframes changeOpacity {
  0% {
    opacity: 0%;
  }

  40% {
    opacity: 40%;
  }

  100% {
    opacity: 100%;
  }
}

.easeShow-enter-active {
  animation: changeOpacity 0.2s ease;
}


.easeShow-leave-active {
  animation: changeOpacity 0.2s reverse;

}

.default-container {
  padding-bottom: 9rem;
}

.line-through {
  text-decoration: line-through;
}

.container-info {
  display: flex;
  text-align: right;
  align-self: center;
  margin-left: 5px;
  justify-content: center;
  z-index: 50;

}

.container-dados-faturamento {
  width: 80%;
  margin: 50px auto;
  padding: 10px 20px;
  max-width: 1260px;
}



.line {
  border: 1px solid rgba(128, 128, 128, 0.603);
}

.footer {
  background-color: #fff;
  z-index: 99999;
  overflow-x: hidden;
  max-height: 100px;
}

.footer .footer-container {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}

ul {
  padding-inline-start: 0px;
}

ul li {
  list-style: none;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}



.activation {
  margin-top: 64px;
}

.activation h3 {
  margin-bottom: 32px;
  font-size: 54px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
  margin-top: 64px;
}

.activation h5 {
  margin-top: 30px;
  margin-bottom: 64px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}



.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.registro::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.registro::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.registro::-webkit-scrollbar-thumb {
  background: #dad7d7;
}

.title {
  color: #222;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -1.13px;
  line-height: 44px;
}

.subtitle {
  color: gray;
  font-size: 1.1rem;
  line-height: 130%;
  font-weight: 400;
  text-align: center;
  width: 100%;
  margin-top: 10px
}

.complementos {
  width: 80%;
  min-height: 300px;
  margin: 50px auto;
  overflow: auto;
  padding: 10px 20px;
  max-width: 1260px;
}

.complementos .item-complementos {
  width: 100%;
  margin: 0 auto;
}

.complementos::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.complementos::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.complementos::-webkit-scrollbar-thumb {
  background: #dad7d7;
}





.selected {
  border: 2px solid #22f387 !important;
}

.complemento .desc {
  color: #385a7b;
  font-size: 1rem;
  /* font-weight: 500; */
  text-align: left;
  margin: .35rem 0;
}

.complemento .valor {
  color: #1cc925;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: normal;
}

.complemento .forma-pag {
  color: #757575;
}

.resumo {
  width: 100%;
  height: 510px;
  margin-top: .5rem;
  overflow: auto;
  border: 1px solid #d3d2d2 !important;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.resumo::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.resumo::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.resumo::-webkit-scrollbar-thumb {
  background: #dad7d7;
}

.resumo-wrapper {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  height: 100%;
}

.plano {
  border-bottom: 1px solid #d3d2d2 !important;
}

.plano-resumo {
  font-size: 1.3rem;
  font-weight: 500;
}

.plano span {
  color: #174B79;
  font-size: 1.3rem;
  font-weight: 500;
}

.plano small {
  color: #757575;
  font-size: .85rem;
  font-weight: 600;
  margin: 0;
}

.plano p {
  font-size: .85rem;
  line-height: .5rem;
  letter-spacing: .03rem;
  margin: 0;
}

.itens-resumo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  color: #385a7b;
}

.itens-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  padding: .35rem 0;
  border-bottom: 1px solid #d3d2d2 !important;
}

.itens-resumo span {
  font-size: 1rem;
  line-height: 1.1rem;
}

.itens-resumo strong {
  font-size: 1rem;
  font-weight: 800;
  min-width: 27%;
  text-align: right;
}

.total-resumo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-resumo span {
  font-size: 1.3rem;
  font-weight: 900;
  text-transform: uppercase;
  margin-top: 1rem;
}

.btn-finalizar {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: .75rem 13%;
  border: none;
  border-radius: 5px;
  background: #1cc925;
  cursor: pointer;
}

.btn-resumo:hover {
  background: #23bb2b;
}

.app-button {
  border: 2px solid #ffe871 !important;
  border-radius: 0.70rem;
  cursor: pointer;
  height: 45px !important;
  background-color: #ffe871 !important;
  color: black !important;
  font-size: 16px !important;
  font-weight: 600;
}

.box-clientes {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #E0E0E0; */
  /* border-radius: 15px; */
  padding: 15px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048
}

.primary {
  background-color: #1cc925;
}

.periodo-info {
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 24px;
}

.duvidas .content {
  font-size: 1rem;
  color: #385a7b;
  padding: 10px;
  margin-bottom: 1rem;
  cursor: pointer;
  border: 1px solid transparent;
}

.duvidas .content:hover {
  border: 1px solid #1cc925 !important;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  box-shadow: 0 5px 15px 0 #3a405048
}

.bottom-bar div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: .5rem;
  width: 50%;
  margin: auto;
}

.bottom-bar span {
  font-size: 1.3rem;
  font-weight: 800;
  margin: 0 .5rem;
  text-transform: uppercase;
}

.button-green {
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 100%;
  height: 100%;
  max-width: 154px;
  max-height: 39px;
  background-color: #ACD22D;
  font-size: 1rem;
  line-height: 130%;
  padding: 9px 0;
  border: 1px solid transparent;
  border-radius: 50px;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  font-weight: 600;

}

.button-green:hover {
  border-color: #ACD22D;
  background-color: #fff;
  color: #ACD22D;
}

.button-light-blue {
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 100%;
  height: 100%;
  /* max-width: 154px; */
  max-height: 39px;
  background-color: #fff;
  font-size: 1rem;
  line-height: 130%;
  padding: 9px 0;
  border: 1px solid #0f3e76;
  border-radius: 50px;
  color: #0f3e76;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  font-weight: 600;
}

.button-light-blue:hover {
  background-color: #0f3e76;
  color: #fff;
}

.card-plano-preco:hover~.button-light-blue {
  background-color: #0f3e76;
  color: #fff;
}

@media only screen and (max-width: 960px) {

  .card-wrapper {
    width: 100%;
    margin: 0;
  }

  .bottom-bar div {
    width: 60%;
  }

  .footer-container div {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    gap: 0;
    overflow-x: hidden;
  }
}

@media only screen and (max-width: 540px) {
  .line {
    display: none !important;
  }

  .container-planos-preco {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .container-planos-preco .box-custom {
    width: 100%;
  }

  .card-plano-preco {
    width: 90%;
    margin: 0 auto;
    max-width: 100%;
    border-radius: 20px;

  }

  .card-plano-preco-destaque {
    width: 90%;
    margin: 0 auto;
    max-width: 100%;
  }

  .card {
    padding: 0 1rem .5rem 1rem;
    border: none;
  }

  .nav {
    margin-top: 1rem;
  }

  .navbar {
    margin: 0 1rem;
  }

  .nav-link {
    font-size: .85rem;
    padding: .5rem 1.5rem;
  }

  .resumo-wrapper {
    padding: 1rem;
  }

  .complemento div {
    width: 100%;
    margin: 0;
  }

  .bottom-bar div {
    width: 90%;
    margin: auto;
    margin-top: .25rem;
  }

  .bottom-bar span {
    font-size: 1.2rem;
  }

  .btn-finalizar {
    font-size: 1rem;
    padding: .75rem 8%;
  }
}</style>



// WEBPACK FOOTER //
// src/forms/app-plano-increment-addons.vue